await import(window.kpCompositeViewerUrl || './kp-composite-viewer.js');
(() => {
  const product = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const products = {
    'custom-white-satin-kippah': {
      color: 'Classic',
      patterns: { single: /White_Satin_Classic/i },
      placements: { single: { x: 1265, y: 2097, angle: 3.5, side: 806 } }
    },
    'custom-lined-satin-kippah': {
      color: 'White',
      patterns: { single: /White_Satin_Lining_Single/i, paired: /White_Satin_Lining_/i },
      placements: {
        single: { x: 1350.04, y: 2097.53, angle: 1.8083, side: 840 },
        outside: { x: 887.26, y: 2256.85, angle: 3.8983, side: 582 },
        inside: { x: 2171.52, y: 1738.37, angle: 24.2037, side: 582 }
      }
    },
    'custom-lined-navy-satin-kippah': {
      color: 'Navy',
      patterns: { single: /custom-lined-navy-satin-kippah|blank-lined-navy-satin-kippah/i, paired: /Blue_Satin_Lining_/i },
      placements: {
        single: { x: 1304.24, y: 2099.15, angle: 6.0043, side: 840 },
        outside: { x: 726.73, y: 2160.73, angle: 22.1891, side: 582 },
        inside: { x: 2075.38, y: 1749.62, angle: 32.7999, side: 582 }
      }
    },
    'custom-lined-black-satin-kippah': {
      color: 'Black',
      patterns: { single: /custom-lined-black-satin-kippah|blank-lined-black-satin-kippah/i, paired: /Black_Satin_Lining_/i },
      placements: {
        single: { x: 1369.09, y: 2114.39, angle: 2.4074, side: 840 },
        outside: { x: 813.63, y: 2211.85, angle: 7.5003, side: 582 },
        inside: { x: 2029.39, y: 1794.61, angle: 24.3004, side: 582 }
      }
    }
  };

  const setup = products[product];
  if (!setup) return;

  if (window.__kpCustomArtworkPreview?.product === product) return;
  window.__kpCustomArtworkPreview?.destroy?.();

  const namespace = 'http://www.w3.org/2000/svg';
  const sourceWidth = 3024;
  const sourceHeight = 4032;
  const fileStates = new Map();
  const controller = new AbortController();
  const { signal } = controller;
  let timer;
  let observer;
  let renderRevision = 0;

  const selectedPlacement = () => {
    if (setup.color === 'Classic') return 'Outside Print';
    const selected = [...document.querySelectorAll('main input[type="radio"][name^="Print Placement-"]:checked')]
      .find((input) => input.closest('main'));
    return selected?.value || '';
  };

  const fileInput = (side) => document.querySelector(`main kp-print-content[data-mode="custom"] [data-side="${side}"] [data-content-file]`);
  const isPreviewable = (file) => {
    if (!file) return false;
    if (/^image\/(?:png|jpe?g)$/i.test(file.type)) return true;
    return /\.(?:png|jpe?g)$/i.test(file.name);
  };

  const syncFileState = (input) => {
    const file = input?.files?.[0];
    const previous = input ? fileStates.get(input) : null;
    if (!input || !file) {
      if (previous?.url) URL.revokeObjectURL(previous.url);
      if (input) fileStates.delete(input);
      return null;
    }
    if (previous?.file === file) return previous;
    if (previous?.url) URL.revokeObjectURL(previous.url);
    const state = { file, previewable: isPreviewable(file), url: '' };
    if (state.previewable) state.url = URL.createObjectURL(file);
    fileStates.set(input, state);
    return state;
  };

  const releaseRemovedInputs = (liveInputs) => {
    fileStates.forEach((state, input) => {
      if (liveInputs.has(input) && input.isConnected) return;
      if (state.url) URL.revokeObjectURL(state.url);
      fileStates.delete(input);
    });
  };

  const updateStatus = (side, state) => {
    const status = document.querySelector(`main kp-print-content[data-mode="custom"] [data-side="${side}"] [data-preview-status]`);
    if (!status) return;
    if (!state) {
      status.hidden = true;
      status.textContent = '';
      return;
    }
    status.hidden = false;
    status.textContent = state.previewable
      ? `${side} artwork is shown in the preview.`
      : 'Preview unavailable for this file type. Your file is still attached for your digital proof.';
  };

  const objectPositionRatio = (value, axis) => {
    const keywords = axis === 'x'
      ? { left: 0, center: 0.5, right: 1 }
      : { top: 0, center: 0.5, bottom: 1 };
    if (Object.hasOwn(keywords, value)) return keywords[value];
    if (value.endsWith('%')) return Number.parseFloat(value) / 100;
    return 0.5;
  };

  const objectPosition = (value) => {
    let x = '';
    let y = '';
    value.trim().split(/\s+/).forEach((token) => {
      if (/^(?:left|right)$/.test(token)) x = token;
      else if (/^(?:top|bottom)$/.test(token)) y = token;
      else if (!x) x = token;
      else if (!y) y = token;
    });
    return [objectPositionRatio(x || '50%', 'x'), objectPositionRatio(y || '50%', 'y')];
  };

  const mapGeometry = (container, sourceImage, geometry) => {
    const containerRect = container.getBoundingClientRect();
    const imageRect = sourceImage.getBoundingClientRect();
    const style = window.getComputedStyle(sourceImage);
    const containScale = Math.min(imageRect.width / sourceWidth, imageRect.height / sourceHeight);
    const coverScale = Math.max(imageRect.width / sourceWidth, imageRect.height / sourceHeight);
    let scaleX = containScale;
    let scaleY = containScale;
    if (style.objectFit === 'cover') scaleX = scaleY = coverScale;
    else if (style.objectFit === 'fill') {
      scaleX = imageRect.width / sourceWidth;
      scaleY = imageRect.height / sourceHeight;
    } else if (style.objectFit === 'none') scaleX = scaleY = 1;
    else if (style.objectFit === 'scale-down') scaleX = scaleY = Math.min(1, containScale);
    const [positionX, positionY] = objectPosition(style.objectPosition);
    const renderedWidth = sourceWidth * scaleX;
    const renderedHeight = sourceHeight * scaleY;
    const left = imageRect.left - containerRect.left + (imageRect.width - renderedWidth) * positionX;
    const top = imageRect.top - containerRect.top + (imageRect.height - renderedHeight) * positionY;
    return {
      x: left + geometry.x * scaleX,
      y: top + geometry.y * scaleY,
      width: geometry.side * scaleX,
      height: geometry.side * scaleY,
      angle: geometry.angle,
      viewBox: `0 0 ${containerRect.width} ${containerRect.height}`
    };
  };

  const makeOverlay = () => {
    const svg = document.createElementNS(namespace, 'svg');
    svg.classList.add('kp-custom-artwork-preview');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    Object.assign(svg.style, {
      position: 'absolute',
      inset: '0',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: '2'
    });
    return svg;
  };

  const drawArtwork = (svg, state, mapped, side, revision) => {
    const image = document.createElementNS(namespace, 'image');
    image.dataset.side = side;
    image.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    image.setAttribute('href', state.url);
    image.setAttribute('x', String(mapped.x - mapped.width / 2));
    image.setAttribute('y', String(mapped.y - mapped.height / 2));
    image.setAttribute('width', String(mapped.width));
    image.setAttribute('height', String(mapped.height));
    image.setAttribute('transform', `rotate(${mapped.angle} ${mapped.x} ${mapped.y})`);
    image.addEventListener('load', () => {
      if (revision !== renderRevision || fileStates.get(fileInput(side)) !== state) image.remove();
    }, { once: true });
    svg.append(image);
  };

  const drawContent = (svg, state, mapped, side, revision) => {
    // Custom text is retained for the production proof, not rendered on the kippah.
    if (!state?.previewable) return;
    drawArtwork(svg, state, mapped, side, revision);
  };

  const activeImages = (pattern) => [...document.querySelectorAll('main img.product-media__image')].filter((image) => {
    const rect = image.getBoundingClientRect();
    const style = window.getComputedStyle(image);
    return rect.width > 240 && rect.height > 240 && style.display !== 'none' && style.visibility !== 'hidden'
      && pattern.test(image.currentSrc || image.src);
  });

  const render = () => {
    renderRevision += 1;
    const revision = renderRevision;
    observer?.disconnect();
    try {
      const root = document.querySelector('main kp-print-content[data-mode="custom"]');
      const placement = selectedPlacement();
      const outsideInput = fileInput('Outside');
      const insideInput = fileInput('Inside');
      const liveInputs = new Set([outsideInput, insideInput].filter(Boolean));
      releaseRemovedInputs(liveInputs);
      const outside = syncFileState(outsideInput);
      const inside = syncFileState(insideInput);
      updateStatus('Outside', outside);
      updateStatus('Inside', inside);

      const isSingle = setup.color === 'Classic' || placement === 'Outside Print';
      const pattern = isSingle ? setup.patterns.single : setup.patterns.paired;
      const images = root && pattern ? activeImages(pattern) : [];
      const activeContainers = new Set();

      images.forEach((sourceImage) => {
        const container = sourceImage.closest('.product-media-container') || sourceImage.parentElement;
        if (!container) return;
        container.toggleAttribute('data-kp-paired-preview', !isSingle);
        sourceImage.style.setProperty('object-fit', 'cover', 'important');
        activeContainers.add(container);
        let svg = container.querySelector(':scope > .kp-custom-artwork-preview');
        if (!svg) {
          svg = makeOverlay();
          if (window.getComputedStyle(container).position === 'static') container.style.position = 'relative';
          container.append(svg);
        }
        const containerRect = container.getBoundingClientRect();
        svg.setAttribute('viewBox', `0 0 ${containerRect.width} ${containerRect.height}`);
        svg.replaceChildren();

        if (isSingle) {
          drawContent(svg, outside, mapGeometry(container, sourceImage, setup.placements.single), 'Outside', revision);
          return;
        }
        if (placement === 'Inside Print') {
          drawContent(svg, inside, mapGeometry(container, sourceImage, setup.placements.inside), 'Inside', revision);
        }
        if (placement === 'Double-Sided Print') {
          drawContent(svg, outside, mapGeometry(container, sourceImage, setup.placements.outside), 'Outside', revision);
          drawContent(svg, inside, mapGeometry(container, sourceImage, setup.placements.inside), 'Inside', revision);
        }
      });

      document.querySelectorAll('.kp-custom-artwork-preview').forEach((svg) => {
        if (!activeContainers.has(svg.parentElement)) svg.remove();
      });
    } finally {
      observer?.observe(document.body, { childList: true, subtree: true });
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(render, 80);
  };

  document.addEventListener('kp:preview-refresh', render, { signal });
  document.addEventListener('change', schedule, { capture: true, signal });
  document.addEventListener('input', schedule, { capture: true, signal });
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('kp-print-content[data-mode="custom"] [data-file-remove], kp-print-content[data-mode="custom"] [data-content-file]')) schedule();
  }, { capture: true, signal });
  document.addEventListener('variant:update', schedule, { capture: true, signal });
  window.addEventListener('popstate', schedule, { signal });
  window.addEventListener('pageshow', schedule, { signal });
  window.addEventListener('resize', schedule, { passive: true, signal });

  const destroy = () => {
    controller.abort();
    observer?.disconnect();
    window.clearTimeout(timer);
    fileStates.forEach((state) => state.url && URL.revokeObjectURL(state.url));
    fileStates.clear();
    document.querySelectorAll('.kp-custom-artwork-preview').forEach((svg) => svg.remove());
    if (window.__kpCustomArtworkPreview?.product === product) delete window.__kpCustomArtworkPreview;
  };

  window.addEventListener('pagehide', destroy, { once: true, signal });
  observer = new MutationObserver((records) => { if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches('media-gallery,kp-print-content,variant-picker') || node.querySelector('media-gallery,kp-print-content,variant-picker'))))) schedule(); });
  observer.observe(document.body, { childList: true, subtree: true });
  window.__kpCustomArtworkPreview = { product, destroy };
  schedule();
})();

